import React from "react";
import useStyles from "../AppPageHeader/styles";
import Box from "@material-ui/core/Box";
import clsx from "clsx";

export interface Props {
  children?: React.ReactNode;
  className?: string;
}

const AppPageHeader = (props: Props) => {
  const { children, className } = props;
  const classes = useStyles();

  return (
    <Box className={clsx(classes.appPageHeader, className)}>{children}</Box>
  );
};

export default AppPageHeader;
